export default {
    async getReports(){ 
        try{
            let result = await ApiClient.get(`/reports`, {embed: ['aggregations.cumulio']})
            return result
        } catch(error){
            return error
        }
    },
}